import gql from 'graphql-tag';

export default gql`
fragment AdminPromotionCategoryAllData on AdminProductCategory {
    id
    name
    parent_id
    url_key
    content
    is_enable
    sort
    date_from
    date_to
    show_in_menu
    keywords
    description
    is_promotion
    promotion_place
    is_homepage_prohibited
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminPromotionCategoryAllData.ts